import React, { useEffect, useState } from "react";

function seededBase(seed = 1) {
    return 800 + ((seed * 137) % 900);
}

export default function FILTVViewerCounter({ seed = 1 }) {
    const [count, setCount] = useState(() => seededBase(seed));

    useEffect(() => {
        setCount(seededBase(seed));
    }, [seed]);

    useEffect(() => {
        const timer = setInterval(() => {
            setCount((prev) => prev + Math.floor(Math.random() * 3));
        }, 5000);

        return () => clearInterval(timer);
    }, []);

    return (
        <div className="text-[10px] sm:text-xs text-green-400 mt-1">
            👁 {count.toLocaleString()} watching
        </div>
    );
}
